/* istanbul ignore file */
import { combineReducers } from 'redux'

import {
    SET_KEYCLOAK_TOKEN,
    RECEIVE_RATES,
    RECEIVE_USER,
} from '../actions/types'

const initialState = {
    data: null,
}

function dataReducer (state = initialState.data, action) {
    switch (action.type) {
        case SET_KEYCLOAK_TOKEN:
            return {
                ...state,
                keycloak: action.token,
            }
        case RECEIVE_USER:
            return {
                ...state,
                keycloak: action.user?.keycloakToken,
            }
        case RECEIVE_RATES:
            return {
                ...state,
                idAnonymous: action.rates && `AnonymousId ${action.rates.idAnonymous}`,
            }
        default:
            return state
    }
}

export default combineReducers({
    data: dataReducer,
})
